var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9253 41.8125C60.3615 42.3727 59.599 42.6871 58.8042 42.6871C58.0094 42.6871 57.2469 42.3727 56.6831 41.8125L54.1921 39.3215C53.6315 38.7578 53.3167 37.9951 53.3167 37.2C53.3167 36.4049 53.6315 35.6421 54.1921 35.0784L59.8303 29.4375C59.8414 29.4267 59.8498 29.4134 59.8545 29.3987C59.8593 29.3839 59.8603 29.3683 59.8575 29.353C59.8547 29.3378 59.8482 29.3235 59.8385 29.3114C59.8289 29.2993 59.8164 29.2898 59.8022 29.2837C56.1628 27.7237 51.4443 28.5187 48.4481 31.4934C45.5812 34.3387 45.4181 38.6184 46.4681 42.3534C46.6173 42.8843 46.6169 43.4461 46.467 43.9768C46.3171 44.5075 46.0236 44.9865 45.6187 45.3609L30 59.625C29.5391 60.0335 29.1668 60.532 28.9057 61.0898C28.6447 61.6476 28.5005 62.2529 28.482 62.8685C28.4635 63.4841 28.5712 64.0969 28.7983 64.6694C29.0254 65.2418 29.3672 65.7618 29.8027 66.1973C30.2381 66.6327 30.7581 66.9745 31.3305 67.2017C31.903 67.4288 32.5158 67.5364 33.1314 67.5179C33.747 67.4994 34.3523 67.3552 34.9101 67.0942C35.4679 66.8332 35.9664 66.4608 36.375 66L50.7993 50.3437C51.169 49.9457 51.64 49.6557 52.1619 49.5049C52.6838 49.3542 53.2368 49.3482 53.7618 49.4878C57.4687 50.4806 61.6875 50.294 64.5168 47.5012C67.5628 44.5012 68.22 39.1987 66.7434 36.164C66.7368 36.1508 66.727 36.1393 66.7151 36.1305C66.7031 36.1217 66.6893 36.1159 66.6746 36.1135C66.66 36.1111 66.645 36.1123 66.6309 36.1168C66.6167 36.1214 66.6039 36.1292 66.5934 36.1397L60.9253 41.8125Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 64.5C33.8284 64.5 34.5 63.8284 34.5 63C34.5 62.1716 33.8284 61.5 33 61.5C32.1716 61.5 31.5 62.1716 31.5 63C31.5 63.8284 32.1716 64.5 33 64.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.07965d63e16b08cbf0b3ac4014285799.svg";
export { ForwardRef as ReactComponent };